export class Event {
  constructor(
    public id: string,
    public name: string,
    public category: string,
    public categoryId: string,
    public selected?: boolean,
  ) {
    if (selected === undefined) {
      selected = false;
    }
  }
}

export class EventCategory {
  constructor(
    public id: string,
    public name: string,
    public selected?: boolean,
  ) {
    if (selected === undefined) {
      selected = false;
    }
  }
}

export interface EventListOption {
  label: string;
  value: string;
}

export interface AlertEventList {
  events: EventListOption[];
  subEvents: { [key: string]: EventListOption[] };
}

export interface ScoreOption {
  value: string;
  label: string;
}

export interface AlertTriggerAdditionalParams {
  z_score_period: string;
  z_score_direction: string;
  z_score_threshold: string;
  operator: string;
  plateau_period: string;
}

export interface AlertTrigger {
  score_type: string;
  threshold: number | string;
  threshold_setting: string;
  isDeltaAlert: boolean;
  additional_params: AlertTriggerAdditionalParams;
}

export function createDefaultTrigger(): AlertTrigger {
  return {
    score_type: '',
    threshold: '',
    threshold_setting: '',
    isDeltaAlert: false,
    additional_params: {
      z_score_period: '7',
      z_score_direction: '',
      z_score_threshold: '',
      operator: '',
      plateau_period: '0',
    },
  };
}
